<script>
    /**
     * Compact language selector (globe + <select>) for pages without the header, e.g. Login.
     */
    import { locale, setLocale, LOCALES, t, suggestion, dismissSuggestion } from './index.js';

    function onChange(e) {
        setLocale(e.target.value);
        if ($suggestion) dismissSuggestion();
    }
</script>

<style>
    .i18n-select { display: inline-flex; align-items: center; gap: 0.35rem; margin: 0; color: #727E8C; }
    .i18n-select i { font-size: 1.15rem; }
    .i18n-select select { width: auto; min-width: 7.5rem; height: calc(1.5em + 0.75rem); padding: 0.1rem 1.6rem 0.1rem 0.5rem; font-size: 0.85rem; cursor: pointer; }
</style>

<label class="i18n-select" title={$t('language.switch')}>
    <i class="bx bx-globe" aria-hidden="true"></i>
    <select class="form-control form-control-sm" value={$locale} on:change={onChange} aria-label={$t('language.label')}>
        {#each LOCALES as l (l.code)}
            <option value={l.code} lang={l.code}>{l.native}</option>
        {/each}
    </select>
</label>
